<template>
  <v-container>
    <v-layout column>
      <v-flex>
        <hzd-field-date-range-filter @input="dateRangeFilter=$event"></hzd-field-date-range-filter>
        <!-- <hzd-broadcasts-local-filters @input="localFilter=$event"></hzd-broadcasts-local-filters> -->
      </v-flex>
      <v-flex xs12>
        <v-flex>
          <v-card>
            <v-card-title>
              Broadcasts
              <v-spacer></v-spacer>
              <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
            </v-card-title>
            <v-data-table :search="search" :headers="headers" :items="filteredItems" :loading="loading" rows-per-page="-1" class="elevation-1">
              <template slot="items" slot-scope="props">
                <td>
                  <b>{{ props.item.name }}</b>
                  <span v-if="props.item.created_at"><br> {{props.item.created_at.toDate() | moment("from")}} </span>
                </td>
                <td>
                  <div class="text-xs-center">
                    <v-chip v-for="(tag,i) in props.item.tags" :key="i">
                      <v-icon left>label</v-icon>{{ tag }}</v-chip>
                  </div>
                </td>
                <td class="text-xs-right">{{ props.item.channel }}</td>
                <td class="text-xs-right">{{ props.item.qty }}</td>
                <td class="text-xs-left">{{ props.item.status }}</td>
              </template>
              <v-alert slot="no-results" :value="true" color="error" icon="warning">
                No se encontraron resultados para su busqueda de "{{ search }}" en el periodo de {{ dateRangeFilter ? dateRangeFilter.fromDate : "" }} a {{dateRangeFilter ? dateRangeFilter.toDate : "" }}.
              </v-alert>
              <template slot="pageText" slot-scope="props">
                Campañas {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
              </template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
//import { db } from "../main";
import firebase from "firebase/app";
import "firebase/firestore";
import { mapGetters } from "vuex";
import hzdFieldDateRangeFilter from "./util/FieldDateRangeFilter";
import hzdBroadcastsLocalFilters from "./util/BroadcastsLocalFilters";

const broadcastsRef = firebase.firestore().collection("broadcasts");

export default {
  data() {
    return {
      search: "",
      filterActive: true,
      dateRangeFilter: null,
      localFilter: null,
      selectedChannels: null,
      headers: [
        {
          text: "Nombre de campaña",
          align: "left",
          sortable: false,
          value: "name"
        },
        {
          text: "Etiquetas",
          sortable: false,
          value: "tags"
        },
        {
          text: "Canal",
          sortable: false,
          value: "channel"
        },
        {
          text: "Cantidad",
          sortable: false,
          value: "qty"
        },
        {
          text: "Estado",
          align: "left",
          sortable: false,
          value: "status"
        }
      ]
    };
  },
  computed: {
    filteredItems: function() {
      return this.filterActive && this.localFilter
        ? this.broadcasts.filter(item => {
            let filter1 =
              this.localFilter.selectedChannels.indexOf(item.channel) > -1;
            let searchText =
              typeof this.localFilter.searchText === "string" &&
              this.localFilter.searchText.length > 0
                ? this.localFilter.searchText
                : false;
            let filter2 = searchText
              ? item.name.toUpperCase().indexOf(searchText.toUpperCase()) > -1
              : true;
            return filter1 && filter2;
          })
        : this.broadcasts;
    },
    ...mapGetters(["broadcasts", "aggregations", "loading", "error"])
  },
  watch: {
    // aggregations() {
    //   let doc = this.aggregations.find(doc => doc.id === "broadcasts");
    // },
    dateRangeFilter() {
      if (this.dateRangeFilter) {
        this.setFirestoreRef();
      }
    }
  },
  methods: {
    setFirestoreRef() {
      let fromDate = this.$moment(this.dateRangeFilter.fromDate).toDate();
      let toDate = this.$moment(this.dateRangeFilter.toDate).toDate();
      this.$store.dispatch("setFirestoreRef", {
        name: "broadcasts",
        ref: this.source
          .orderBy(this.dateRangeFilter.field, "desc")
          .where(this.dateRangeFilter.field, ">=", fromDate)
          .where(this.dateRangeFilter.field, "<=", toDate)
        // ref: this.source
        //   .orderBy("qry_1234", "asc")
        //   .where("qry_1234", ">", 0)
      });
    }
  },
  created() {
    this.source = broadcastsRef;
  },
  components: {
    hzdFieldDateRangeFilter,
    hzdBroadcastsLocalFilters
  }
};
</script>
